import { useSyncExternalStore } from 'react';
import { subscribeDatePreset, getDatePreset, DatePresetKey } from './dateFormat';

/**
 * Subscribes a component to the active date-format preset. Returning the key is
 * incidental — the main purpose is to re-render the subtree when the preset
 * changes so plain formatDate/formatTime/... calls re-read the new locale.
 */
export function useDatePreset(): DatePresetKey {
  return useSyncExternalStore(subscribeDatePreset, getDatePreset, getDatePreset);
}
